import Vue from 'vue';
import { getAccessToken } from '@/assets/js/auth';

export default Vue.mixin({
  methods: {
    async deployOpenstack(newTeamId, responseCallback, errorCallback) {
      let teamId = '';
      if (newTeamId) {
         teamId = newTeamId;
      } else {
         teamId = localStorage.getItem('current_team_id');
      }
      let projectData = {
        name: this.$store.state.customer.info.name ? this.$store.state.customer.info.name : 'temp_name'
      }
      let projectName = localStorage.getItem('tempProjectName');

      if (projectName) {
        projectData.name = projectName;
      }

      const settings = {
        headers: {
          'Authorization': 'Bearer ' + getAccessToken()
        }
      };
      await this.$http.post(`/api/openstack/projects?team_id=${teamId}`, projectData, settings)
      .then((response) => {
        responseCallback(response);
      })
      .catch((error) => {
        if (error !== undefined && error.response !== undefined && error.response.data !== undefined) {
          errorCallback(error.response.data);
        }
      });
    },

    async getProposed(newTeamId, newTeam) {
      await this.deployOpenstack(newTeamId, (response) => {
        this.showNotification('info', `Preparing your environment, this can take a moment.`);
        this.$root.$emit('bv::hide::modal','billing-modal');
        if (newTeam) {
            this.$store.commit('misc/DEPLOYING_NEW_TEAM', true);
        }
        this.$store.commit('misc/DEPLOYING_ENVIRONMENT', true);
        localStorage.removeItem('current_namespace')
        this.pollProjectStatus();
      }, (error) => {
        this.$root.$emit('bv::show::modal','billing-modal');
        if (error.proposed === 'customer:patch' || error.proposed === 'customer:post') {
          let usage = localStorage.getItem('usage');
          if (usage === 'personal') {
            this.switchBillingModal('SHOW_FORM_PERSONAL_DETAILS');
          } else {
            this.switchBillingModal('SHOW_FORM_BUSINESS_DETAILS');
          }
        } else if (error.proposed === 'payment-methods:post') {
          this.switchBillingModal('SHOW_ADD_PAYMENT_METHOD');
        } else if (error.message === 'You already deployed an openstack environment.') {
          window.location = '/';
        }
      });

      setTimeout(() => {
        this.$store.commit('misc/PAGE_LOADING', false);
      }, 500 );
    },

    findRegistrationStep(url, otherTeamId) {
      let teamId = '';
      if(url !== undefined) {
        localStorage.setItem('next', url);
      } else {
        localStorage.setItem('next', '/');
      }
      if (this.isLoggedIn) {
        teamId = otherTeamId ? otherTeamId : localStorage.getItem('current_team_id');
        if (teamId === null) {
          let usage = localStorage.getItem('usage');
          if (usage === null) {
            this.switchBillingModal('SHOW_FUGA_USAGE');
          } else {
            if (usage === 'personal') {
              this.switchBillingModal('SHOW_FORM_PERSONAL_DETAILS');
            } else if (usage === 'business') {
              this.switchBillingModal('SHOW_FORM_BUSINESS_DETAILS');
            }
          }
        } else {
          this.getProposed(otherTeamId);
        }
      } else {
        this.$router.push({name: 'login'});
      }
    },
  },
});
